/* eslint-disable import/no-anonymous-default-export */
import { BusinessInformation } from "./BusinessInformation";
import { BusinessNatue } from "./BusinessNature";
import { SubscriptionPage } from "./SubscriptionPage";
import { BusinessRegistrationInfo } from "./BusinessRegistrationInfo";


export default {
  BusinessInformation,
  BusinessNatue,
  BusinessRegistrationInfo,
  SubscriptionPage
}


